/* eslint-disable @typescript-eslint/no-explicit-any */

import { BaseComponent } from "../BaseComponent/BaseComponent";

export default class WizardPage extends BaseComponent<any, never> {
    render() {
        return this.props.children;
    }
}
